import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ShoppingCatalog"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 9.75H21V11.25H3.9L5.175 19.5H11.25V21H5.175C4.425 21 3.75 20.475 3.675 19.725L2.25 10.65V10.5C2.25 10.05 2.55 9.75 3 9.75H7.5V6.75C7.5 5.475 8.475 4.5 9.75 4.5H14.25C15.525 4.5 16.5 5.475 16.5 6.75V9.75ZM9.75 6C9.3 6 9 6.3 9 6.75V9.75H15V6.75C15 6.3 14.7 6 14.25 6H9.75ZM21 18H18V21H21V18ZM15.75 12.75V15.75H12.75V12.75H15.75ZM21 12.75H18V15.75H21V12.75ZM12.75 21V18H15.75V21H12.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ShoppingCatalog.vue"]]);
